export const asHome = {
  data: `<svg width="18" height="17" viewBox="0 0 18 17" xmlns="http://www.w3.org/2000/svg">
  <path d="M6 17C6.55228 17 7 16.5523 7 16V12C7 11.4477 7.44771 11 8 11H10C10.5523 11 11 11.4477 11 12V16C11 16.5523 11.4477 17 12 17H15C15.5523 17 16 16.5523 16 16V9.83196C16 9.37248 16.3725 9 16.832 9C17.5944 9 17.9552 8.05972 17.3885 7.54966L9.66897 0.602068C9.28866 0.259794 8.71134 0.259794 8.33104 0.602068L0.611495 7.54965C0.0447519 8.05972 0.405569 9 1.16804 9C1.62752 9 2 9.37248 2 9.83196V16C2 16.5523 2.44772 17 3 17H6Z" />
  </svg>`,
  name: 'home',
};
